var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurgery = function SvgSurgery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M32.383 5.621c14.36 0 26 11.64 26 26s-11.64 26-26 26-26-11.64-26-26 11.64-26 26-26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00484E",
    d: "M31.18 17.52c-2.34 0-4.58.92-6.24 2.58l-9.76 9.76a3.73 3.73 0 0 0 0 5.28 3.73 3.73 0 0 0 5.28 0l9.7-9.7h9.7L25.1 40.2c-.7.7-1.1 1.66-1.1 2.64 0 2.06 1.68 3.74 3.74 3.74h.02c.98 0 1.92-.38 2.6-1.08-.7.68-1.1 1.64-1.1 2.62 0 2.06 1.68 3.74 3.74 3.74 1 0 1.94-.4 2.64-1.1h-.02c-.68.7-1.08 1.64-1.08 2.62v.12c0 2.02 1.64 3.66 3.66 3.66 1.04 0 2.02-.44 2.72-1.22l6.84-7.6h3.52c2.78 0 5.38-1.3 7.06-3.52v-27.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m29.281 45.36 8.18-8.18 1.24 1.24-8.18 8.18zM34.578 50.637l8.18-8.18 1.24 1.24-8.18 8.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "m6.38 49.258 42.1-42.1c.7-.7 1.64-1.08 2.62-1.08h.02c2.06 0 3.72 1.66 3.72 3.72 0 1-.4 1.96-1.12 2.66l-32.36 31.5v4.4l-4.46 4.46c-2.8 2.8-6.58 4.36-10.54 4.36v-7.94z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7EB",
    d: "m44.523 14.619 1.24-1.24 1.76 1.76-1.24 1.24zM41.883 17.28l1.24-1.24 1.76 1.76-1.24 1.24zM47.18 11.978l1.24-1.24 1.76 1.76-1.24 1.24zM39.242 19.92l1.24-1.24 1.76 1.76-1.24 1.24zM36.602 22.556l1.24-1.24 1.76 1.76-1.24 1.24zM25.14 34.017l1.24-1.24 1.76 1.76-1.24 1.24zM22.5 36.658l1.24-1.24 1.76 1.76-1.24 1.24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m9.302 53.619-.56-1.68c1.64-.54 3.14-1.4 4.44-2.54l4.96-4.34 1.16 1.32-4.96 4.34c-1.48 1.3-3.18 2.28-5.04 2.88z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M32.822 25.457a4.4 4.4 0 0 0-4.4 4.4c0 2.42 1.98 4.4 4.4 4.4h10.58l1.78 2a17.64 17.64 0 0 0 13.2 5.92v-16.72z"
  })));
};
export default SvgSurgery;